import { getCollection, useCollection } from "hooks/firestore/core/useCollection"
import { WithRef } from "hooks/firestore/FirestoreDocument"
import { getDiscountCodesRef } from "hooks/firestore/getRefs"
import { useShopId } from "hooks/localstate/context/useShopId"
import DiscountCode from "types/firestore/discountCode"

// ts-prune-ignore-next
export function useDiscountCodes(): WithRef<DiscountCode>[] | undefined
export function useDiscountCodes(shopId: string): WithRef<DiscountCode>[] | undefined
export function useDiscountCodes(shopId?: string) {
  // TypeScript function overloads should prevent conditional calling of the hook
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const realShopId = shopId || useShopId()
  const { documents } = useCollection(getDiscountCodesRef(realShopId))
  return documents
}

// ts-prune-ignore-next
export async function getDiscountCodes(shopId: string) {
  return await getCollection(getDiscountCodesRef(shopId))
}
